export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    // TODO later
    onClick() {
      this.$emit('click', this.item.value);
    }
  }
};
